<template>
<div class="signup">
  <h1 class="title">{{ $t('form.SignInWithEmail') }}</h1>
  <p>
    {{ $t('msg["Sent verification email"]') }}
  </p>
</div>
</template>
<script>
export default {
  name: 'SentEmailToSignIn',
}
</script>

